const initialState = global.__PRELOADED_STATE__.confirmation || null;

export default (state = initialState) => state;
